<template>

  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <ValidationObserver v-slot="{ invalid, handleSubmit}" slim>
          <form @submit.prevent="handleSubmit(saveAbsence)" class="row form">
            <div class="col-md-4">
              <div class="form-group">
                <DateInputField
                    v-model="date"
                    labelText="datum" required
                    :inMonth="getYearMonthAsString()"/>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Type afwezigheid</label>
                <select
                    v-model="absenceType" required
                    class="form-control">
                  <option disabled value="undefined">Kies het type afwezigheid</option>
                  <option value="EXCUSED_ABSENCE">Klein verlet</option>
                  <option value="EDUCATIONAL_LEAVE">Vlaams Opleidingsverlof</option>
                  <option value="PERSONAL_LEAVE">Familiaal verlof</option>
                  <option value="UNPAID_LEAVE">Onbetaald verlof</option>
                  <option value="SICK_LEAVE">Ziekte</option>
                  <option value="VACATION">Vakantie</option>
                </select>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Duur van de afwezigheid</label>
                <select
                    v-model="fullDay" required
                    class="form-control">
                  <option disabled value="undefined">Duur van de afwezigheid</option>
                  <option value=true>Volledige dag</option>
                  <option value=false>Halve dag</option>
                </select>
              </div>
            </div>

            <div class="form-row align-items-center py-3">
              <div class="input-group ml-4">
                <button
                    type="submit" :disabled="invalid"
                    class="btn-basic btn-green">
                  Opslaan
                </button>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>

</template>

<script>

import {ValidationObserver} from "vee-validate";
import DateInputField from "@/components/inputFields/DateInputField";
import {toYearAndMonth} from "@/util/DateUtil";
import moment from "moment";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "AdminCreateAbsence",
  components: {
    ValidationObserver,
    DateInputField
  },
  data() {
    return {
      date: "",
      absenceType: undefined,
      fullDay: undefined,
    };
  },
  computed: {
    ...mapGetters({
      selectedTimesheetInfo: "administrationTimeSheet/selectedTimeSheetInfo",
      currentlySelectedMonth: "time/currentlySelectedMonth"
    })
  },
  methods: {
    ...mapActions("administrationTimeSheet", ['addAbsence']),
    saveAbsence() {
      const dayOfMonth = moment(this.date).date();
      const absenceCategory = this.absenceType;
      const fullDay = this.fullDay;
      const yearMonth = moment(this.currentlySelectedMonth).format("YYYY-MM");
      const userId = this.selectedTimesheetInfo.userId;

      const createAbsenceDto = {
        dayOfMonth,
        absenceCategory,
        fullDay
      };

      this.addAbsence({yearMonth, userId, createAbsenceDto})
          .then(() => {
            this.resetFields();
            this.$emit('absenceAdded');
          });
    },
    resetFields() {
      this.date = "";
      this.absenceType = undefined;
      this.fullDay = undefined;
    },
    getYearMonthAsString() {
      return toYearAndMonth(this.currentlySelectedMonth);
    }
  },
};
</script>

<style scoped>

</style>